/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Progress } from 'antd';

import colors from '../constants/Colors';

function BoardCardProgressIcon({
  percentage,
  isCardView = false,
}) {
  return (
    <Row
      align="middle"
      className="board-card-days-in-status-container"
      style={{ transform: isCardView ? 'translateY(-4px)' : undefined, width: 50 }}
    >
      <Progress
        percent={percentage}
        type="circle"
        width={15}
        trailColor={colors.GRAY_200}
        strokeColor={colors.REDESIGN_PRIMARY}
        strokeWidth={25}
        format={() => null}
      />
      <span
        className="board-card-days-in-status-text"
        style={{ marginTop: 3 }}
      >
        {`${percentage ?? 0}%`}
      </span>
    </Row>
  );
}

BoardCardProgressIcon.propTypes = {
  percentage: PropTypes.number.isRequired,
  isCardView: PropTypes.bool,
};

export default BoardCardProgressIcon;
